import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';
import { SelectField, TextAreaField } from 'common/components/form_fields';

const Form = ({ onSubmit, handleSubmit, modal, projectOptions, cancel }) => {
  const classes = classnames({ succeeded: modal.success });

  return (<div className={classes}>
    <form onSubmit={handleSubmit(onSubmit)} >
      <Field name="project" component={SelectField} label="Project" options={projectOptions} />
      <Field name="message" component={TextAreaField} label="Message" maxCharCount={1024}
        rows={8} />
      <div className="modal-actions">
        { !modal.isLoading && <button className="btn btn-primary" type="submit">Send</button> }
        { modal.isLoading && <button type="button" className="btn btn-primary">Sending...</button> }
        <button type="button" className="btn btn-text" onClick={cancel}>Cancel</button>
      </div>
    </form>
  </div>);
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modal: PropTypes.shape({
    isLoading: PropTypes.bool,
    creative: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
    success: PropTypes.object,
    error: PropTypes.object,
  }).isRequired,
  projectOptions: PropTypes.array.isRequired,
  cancel: PropTypes.func.isRequired,
};

export default Form;



// WEBPACK FOOTER //
// ./invite/components/form.jsx